export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#C83E44',
    light: '#f9ebec',
    contrastText: "#FFFFFF"
  },
  secondary: {
    main: '#3F3F3F',
    contrastText: '#0A5285',
    light: '#F5F5F5'
  },
  text: {
    primary: '#141B22',
    secondary: '#5A7184',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F5F5F5',
    paper: '#FFF',
    default: '#FFF',
    header: '#F5F5F5',
    footer: '#1C1C1C',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#C83E44',
    tableSubhead: '#F5F5F5',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#e5f5fd',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#3F3F3F',
    secondary: '#F8D859',
    light: '#deeabd',
    arrow: '#FFF',
    secondaryLight: 'rgba(238, 246, 250, 0.6)'
  },
  verticalBar: {
    used: '#C83E44',
    unused: '#f9ebec',
    unlimited: '#C0C0C0',
  }
};